import React from "react";
import {connect} from "react-redux";
import {Link as RouterLink} from "react-router-dom";
import Link from '@material-ui/core/Link'
import {sendConnectionRequestEmail} from "../../actions/connectionActions";
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import StorageOutlinedIcon from '@material-ui/icons/StorageOutlined';
import DeleteIcon from '@material-ui/icons/Delete';
import Typography from '@material-ui/core/Typography';
import {ThemeProvider, withStyles} from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import {Field, FieldArray, reduxForm, SubmissionError} from "redux-form";
// import FormHelperText from "@material-ui/core/FormHelperText";
import _ from "lodash";
import styles from "./ConnectionRequestStyles";

import {theme} from '../Dashboard/theme';
import Paper from "@material-ui/core/Paper";
import Copyright from "../../components/Copyright";
import AddBoxIcon from "@material-ui/icons/AddBox";
import {List, ListItem} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";

let themeCustom = {
  ...theme,
};

const validate = values => {
  const errors = {};

  const requiredFields = [
    'fullName',
    'city',
    'state',
    'country',
    'ailment'
  ];

  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = 'Required'
    }
  });
  return errors
};

// const renderFromHelper = (touched, error) => !(touched && error) ? null : touched && error;

class ConnectionRequest extends React.Component {


  renderTextField = ({
                       input, label,
                       meta: {touched, invalid, error},
                       ...custom
                     }) => (
    <TextField
      style={{marginTop: '1px'}}
      label={label}
      placeholder={label}
      error={touched && invalid}
      helperText={touched && invalid && error}
      variant="outlined"
      margine="normal"
      fullWidth

      {...input}
      {...custom}
    />
  );


  onSubmit = (formValues) => {
    return this.props.sendConnectionRequestEmail(formValues).then(() => {
      const {errors, message} = this.props.error;
      if (!_.isEmpty(errors)) {
        errors.forEach(error => {
          const myKeys = Object.keys(error);
          const key = myKeys[0];
          const value = error[key];
          //     if (key === 'email' || key === 'tag') {
          //       throw new SubmissionError({email: value, _error: message})
          //     }
          //     if (key === 'password') {
          //       throw new SubmissionError({password: value, _error: message})
          //     }
          //     if (key === 'password2') {
          //       throw new SubmissionError({password2: value, _error: message})
          //     }
          // if (key === 'password2') {
          throw new SubmissionError({key: value, _error: message})
          // }
        });
      }
    });
  };

  render() {
    const {classes, handleSubmit} = this.props;

    const renderSymptoms = ({fields, meta: {error, submitFailed}}) => (
      <>
        <Typography component="h3" variant="h6" className={classes.addButton}>Symptoms:</Typography>
        <Button
          startIcon={<AddBoxIcon/>}
          variant="contained"
          color="primary"
          className={classes.buttonAdd}
          onClick={() => fields.push()}
        >
          Add
        </Button>
        <List>
          <ListItem>
            {submitFailed && error && <span>{error}</span>}
          </ListItem>
          {
            fields.map((symptom, index) => (
              <ListItem key={index}>
                {/*<Typography component="span">Symptom #{index + 1}</Typography>*/}
                <Grid container direction="row" spacing={2} xs={12}>
                  <Grid item xs={10}>
                    <Field
                      name={`${symptom}`}
                      type="text"
                      component={this.renderTextField}
                      label={`Symptom ${index + 1}`}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <IconButton
                      aria-label="delete"
                      color="secondary"
                      onClick={() => fields.remove(index)}
                    >
                      <DeleteIcon fontSize="large"/>
                    </IconButton>
                  </Grid>
                </Grid>
              </ListItem>
            ))
          }
          <ListItem>
            {
              fields.length ? null :
                <Typography>
                  If you are experiencing any symptoms ADD them here
                </Typography>}

          </ListItem>
        </List>
      </>
    )

    return (
      <ThemeProvider theme={themeCustom}>
        <Container component="main" maxWidth="xs" style={{
          minHeight: "100%",
          minWidth: "100%",
          display: "flex",
          flexDirection: "column"
        }}>
          <CssBaseline/>
          <Container className={classes.paper}
                     style={{
                       marginTop: "1px",
                       flex: "1 0 auto",
                       maxWidth: "600px"
                     }}>
            <Avatar className={classes.avatar}>
              <StorageOutlinedIcon/>
            </Avatar>
            <Typography component="h1" variant="h5">
              Connection Request
            </Typography>
            <Grid>
              <Paper className={classes.paper}>
                <Container>
                  <Typography color="black" style={{"padding-top": "12px", "padding-bottom": "0px"}}>
                    Please note: there are over 10k known ailments. If yours is not listed, it does not mean that Brandy
                    has not worked with it. It simply means that it has not yet been added. 10k is a lot! With that
                    amount, if we add 5 per day, it will take us over 5 years. So, if yours is not here, no worries.
                    Please fill out the form and we can add it for you.
                  </Typography>
                  <form className={classes.form} noValidate onSubmit={handleSubmit(this.onSubmit)}>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Field
                          name="fullName"
                          component={this.renderTextField}
                          label="Full Name"
                          autoComplete="name"
                          variant="outlined"
                          required
                          fullWidth
                          id="fullName"
                          autoFocus
                        />
                      </Grid>
                      <Grid item xs={8}>
                        <Field
                          name="city"
                          component={this.renderTextField}
                          variant="outlined"
                          required
                          fullWidth
                          id="city"
                          label="City"
                          autoComplete="address-level2"
                        />
                      </Grid>
                      <Grid item xs={4}>
                        <Field
                          name="state"
                          component={this.renderTextField}
                          variant="outlined"
                          required
                          fullWidth
                          id="state"
                          label="State"
                          autoComplete="address-level1"
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Field
                          name="country"
                          component={this.renderTextField}
                          variant="outlined"
                          required
                          fullWidth
                          id="country"
                          label="Country"
                          autoComplete="country"
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Field
                          variant="outlined"
                          component={this.renderTextField}
                          required
                          fullWidth
                          name="ailment"
                          label="Ailment"
                          id="ailment"
                          autoComplete="off"
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <FieldArray
                          name="symptoms"
                          id="symptomList"
                          component={renderSymptoms}
                        />
                      </Grid>
                      <Grid container justify="center">
                        <Button
                          type="submit"
                          variant="contained"
                          fullWidth
                          color="primary"
                          className={classes.submit}
                        >
                          Submit
                        </Button>
                      </Grid>
                      <Grid container justify="flex-end">
                        <Grid item style={{marginTop: "24px"}}>
                          <Link component={RouterLink} to="/dashboard/query" variant="body2">
                            Go back
                          </Link>
                        </Grid>
                      </Grid>
                    </Grid>
                  </form>
                </Container>
              </Paper>
            </Grid>
          </Container>
          <Copyright textColor={theme.palette.primary.light}/>
        </Container>
      </ThemeProvider>
    );// End return
  };// End render
}// End class

const mapStateToProps = (state) => {
  return ({
    error: state.error
  });
};

const mapDispatchToProps = dispatch => ({
  sendConnectionRequestEmail: formValues => dispatch(sendConnectionRequestEmail(formValues))
});


ConnectionRequest = withStyles(styles, {withTheme: true})(ConnectionRequest);

ConnectionRequest = connect(
  mapStateToProps,
  mapDispatchToProps
)(ConnectionRequest);

ConnectionRequest = reduxForm({
  form: 'RequestConnectionForm',
  RequestConnection: ConnectionRequest,
  validate
})(ConnectionRequest);

export default ConnectionRequest;